export default "__VITE_ASSET__DbrESaCO__"